"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.includes");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IKeywordShortcode", {
  enumerable: true,
  get: function get() {
    return _main.IKeywordShortcode;
  }
});
Object.defineProperty(exports, "formatSMSLink", {
  enumerable: true,
  get: function get() {
    return _MOLink.formatSMSLink;
  }
});
exports.default = exports.mockedLoadingState = exports.mockedFailureState = exports.mockedSuccessState = exports.initialState = void 0;

var React = _interopRequireWildcard(require("react"));

var RDS = _interopRequireWildcard(require("../../common-types/RemoteDataState"));

var _main = _interopRequireWildcard(require("./main"));

var _MOLink = require("../common-components/MOLink");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = RDS.NothingYet();
exports.initialState = initialState;
var mockedSuccessState = RDS.Success({
  keyword: 'TEST OK',
  shortcode: '666'
});
exports.mockedSuccessState = mockedSuccessState;
var mockedFailureState = RDS.Failure("Mocked Network Error");
exports.mockedFailureState = mockedFailureState;
var mockedLoadingState = RDS.Loading();
exports.mockedLoadingState = mockedLoadingState;

var _default = function _default(tracker, Comp, maybeConfig, strategy) {
  return function (initialState) {
    var _temp;

    var HOC = (_temp = /*#__PURE__*/function (_React$PureComponent) {
      _inherits(HOC, _React$PureComponent);

      var _super = _createSuper(HOC);

      function HOC() {
        var _this;

        _classCallCheck(this, HOC);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty(_assertThisInitialized(_this), "state", {
          currentState: initialState,
          keyword: null,
          shortcode: null,
          isLoaded: false
        });

        _defineProperty(_assertThisInitialized(_this), "actions", {
          moLink: null,
          onSetKeyword: function onSetKeyword(keyword) {
            _this.setState({
              keyword: keyword
            });

            (0, _main.default)(window, maybeConfig, keyword, null, strategy).then(function (x) {
              return _this.setState({
                currentState: RDS.Success(x)
              });
            }).catch(function (e) {
              return _this.setState({
                currentState: RDS.Failure(e.toString())
              });
            });
          },
          onSetKeywordAndShortcode: function onSetKeywordAndShortcode(keyword, shortcode) {
            _this.setState({
              keyword: keyword,
              shortcode: shortcode
            });

            (0, _main.default)(window, maybeConfig, keyword, shortcode, strategy).then(function (x) {
              return _this.setState({
                currentState: RDS.Success(x)
              });
            }).catch(function (e) {
              return _this.setState({
                currentState: RDS.Failure(e.toString())
              });
            });
          }
        });

        return _this;
      }

      _createClass(HOC, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (!maybeConfig || !!maybeConfig && maybeConfig.isclick2smsLoadOnClick != true) {
            if (!!maybeConfig && maybeConfig.tag == "keywordAndShortCode") {
              this.setState({
                currentState: RDS.Success(_objectSpread({
                  type: "SingleSubmissionResult"
                }, maybeConfig))
              });
            } else if (!!maybeConfig && maybeConfig.tag != "keyword" || !maybeConfig) {
              this.setState({
                currentState: RDS.Loading()
              });
              (0, _main.default)(window, maybeConfig, null, null, strategy).then(function (x) {
                return _this2.setState({
                  currentState: RDS.Success(x)
                });
              }).catch(function (e) {
                return _this2.setState({
                  currentState: RDS.Failure(e.toString())
                });
              });
              console.log("currentState", this.state.currentState);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this3 = this;

          var self = this;
          var moLink = RDS.match({
            nothingYet: function nothingYet() {
              return function (_ref) {
                var children = _ref.children,
                    props = _objectWithoutProperties(_ref, ["children"]);

                return /*#__PURE__*/React.createElement("a", _extends({
                  "data-state": "nothingYet",
                  onClick: function onClick() {
                    console.info("nothingYet");

                    if (!!maybeConfig && maybeConfig.isclick2smsLoadOnClick == true && _this3.state.isLoaded == false) {
                      _this3.setState({
                        currentState: RDS.Loading()
                      });

                      (0, _main.default)(window, maybeConfig, null, null, strategy).then(function (x) {
                        return _this3.setState({
                          currentState: RDS.Success(x),
                          isLoaded: true
                        });
                      }).catch(function (e) {
                        return _this3.setState({
                          currentState: RDS.Failure(e.toString())
                        });
                      });
                    }
                  },
                  href: "javascript: void(0)"
                }, props), children);
              };
            },
            loading: function loading() {
              return function (_ref2) {
                var children = _ref2.children,
                    props = _objectWithoutProperties(_ref2, ["children"]);

                return /*#__PURE__*/React.createElement("a", _extends({
                  "data-state": "loading",
                  onClick: function onClick() {
                    return console.info("loading");
                  },
                  href: "javascript: void(0)"
                }, props), children);
              };
            },
            failure: function failure(error) {
              return function (_ref3) {
                var children = _ref3.children,
                    props = _objectWithoutProperties(_ref3, ["children"]);

                return /*#__PURE__*/React.createElement("a", _extends({
                  "data-state": "failure",
                  onClick: function onClick() {
                    return console.error(error);
                  },
                  href: "javascript: void(0)"
                }, props), children);
              };
            },
            success: function success(result) {
              return function (_ref4) {
                var children = _ref4.children,
                    keyword = _ref4.keyword,
                    shortcode = _ref4.shortcode,
                    operators = _ref4.operators,
                    props = _objectWithoutProperties(_ref4, ["children", "keyword", "shortcode", "operators"]);

                if (result.type == "SingleSubmissionResult") {
                  var keywordAndShortcode1 = {
                    keyword: keyword || result.keyword,
                    shortcode: shortcode || result.shortcode
                  };

                  if (!!maybeConfig && maybeConfig.isclick2smsLoadOnClick == true) {
                    tracker.advancedInFlow("click2sms", "click", keywordAndShortcode1);
                    window.location.href = (0, _MOLink.formatSMSLink)(keywordAndShortcode1);

                    try {
                      (0, _main.checkSubscription)(window, maybeConfig, strategy).then(function (product_url) {
                        tracker.advancedInFlow('click2sms', 'sale', {
                          keywordAndShortcode1: keywordAndShortcode1
                        });
                        setTimeout(function () {
                          window.location.href = product_url;
                        }, 1000);
                      });
                    } catch (err) {
                      throw err;
                    }
                  }

                  return /*#__PURE__*/React.createElement(_MOLink.MOLink, _extends({
                    onClick: function onClick() {
                      tracker.advancedInFlow("click2sms", "click", keywordAndShortcode1);

                      try {
                        (0, _main.checkSubscription)(window, maybeConfig, strategy).then(function (product_url) {
                          tracker.advancedInFlow('click2sms', 'sale', {
                            keywordAndShortcode1: keywordAndShortcode1
                          });
                          setTimeout(function () {
                            window.location.href = product_url;
                          }, 1000);
                        });
                      } catch (err) {
                        throw err;
                      }
                    },
                    keywordAndShortcode: keywordAndShortcode1
                  }, props), children);
                } else {
                  //console.log("result", result)
                  return /*#__PURE__*/React.createElement(React.Fragment, null, result.data && result.data.map(function (obj, index) {
                    var keywordAndShortcode1 = {
                      keyword: keyword || obj.keyword,
                      shortcode: shortcode || obj.shortcode
                    };

                    if (!!operators && operators.length > 0 && operators.includes(obj.operator)) {
                      return /*#__PURE__*/React.createElement(_MOLink.MOLink, _extends({
                        key: index,
                        onClick: function onClick() {
                          return tracker.advancedInFlow("click2sms", "click", keywordAndShortcode1);
                        },
                        keywordAndShortcode: keywordAndShortcode1
                      }, props), children);
                    } else if (!operators) {
                      return /*#__PURE__*/React.createElement(_MOLink.MOLink, _extends({
                        key: index,
                        onClick: function onClick() {
                          return tracker.advancedInFlow("click2sms", "click", keywordAndShortcode1);
                        },
                        keywordAndShortcode: keywordAndShortcode1
                      }, props), children);
                    }
                  }));
                }
              };
            }
          })(this.state.currentState);
          var moLinks = RDS.match({
            nothingYet: function nothingYet() {
              return function (_ref5) {
                var children = _ref5.children,
                    props = _objectWithoutProperties(_ref5, ["children"]);

                return /*#__PURE__*/React.createElement("a", _extends({
                  "data-state": "nothingYet",
                  onClick: function onClick() {
                    return console.info("nothingYet");
                  },
                  href: "javascript: void(0)"
                }, props), children);
              };
            },
            loading: function loading() {
              return function (_ref6) {
                var children = _ref6.children,
                    props = _objectWithoutProperties(_ref6, ["children"]);

                return /*#__PURE__*/React.createElement("a", _extends({
                  "data-state": "loading",
                  onClick: function onClick() {
                    return console.info("loading");
                  },
                  href: "javascript: void(0)"
                }, props), children);
              };
            },
            failure: function failure(error) {
              return function (_ref7) {
                var children = _ref7.children,
                    props = _objectWithoutProperties(_ref7, ["children"]);

                return /*#__PURE__*/React.createElement("a", _extends({
                  "data-state": "failure",
                  onClick: function onClick() {
                    return console.error(error);
                  },
                  href: "javascript: void(0)"
                }, props), children);
              };
            },
            success: function success(result) {
              return function (_ref8) {
                var children = _ref8.children,
                    keyword = _ref8.keyword,
                    shortcode = _ref8.shortcode,
                    props = _objectWithoutProperties(_ref8, ["children", "keyword", "shortcode"]);

                return /*#__PURE__*/React.createElement("div", null, result.data.map(function (obj, index) {
                  var keywordAndShortcode1 = {
                    keyword: keyword || obj.keyword,
                    shortcode: shortcode || obj.shortcode
                  };
                  return /*#__PURE__*/React.createElement(_MOLink.MOLink, _extends({
                    onClick: function onClick() {
                      tracker.advancedInFlow("click2sms", "click", keywordAndShortcode1);

                      try {
                        (0, _main.checkSubscription)(window, maybeConfig, strategy).then(function (product_url) {
                          tracker.advancedInFlow('click2sms', 'sale', {
                            keywordAndShortcode1: keywordAndShortcode1
                          });
                          setTimeout(function () {
                            window.location.href = product_url;
                          }, 1000);
                        });
                      } catch (err) {
                        throw err;
                      }
                    },
                    keywordAndShortcode: keywordAndShortcode1
                  }, props), children);
                }));
              };
            }
          })(this.state.currentState);
          self.actions.moLink = moLink;
          return /*#__PURE__*/React.createElement(Comp, _extends({}, this.props, {
            currentState: this.state.currentState,
            actions: this.actions,
            MOLink: self.actions.moLink,
            strategyConfig: strategy ? strategy : undefined
          }));
        }
      }]);

      return HOC;
    }(React.PureComponent), _temp);
    HOC.prototype['_client'] = "tallyman.v1-click2sms";
    return HOC;
  };
};

exports.default = _default;